import { initializeCartMagento } from "../../../../common/constants/shop-api";
import environment from "../../../../common/environment";
import { getResponseData } from "../../../../common/utils/api-utils";
import { InitializeCartRequest, InitializeCartResponse } from "../interface/initialize-cart.interface";

export async function initializeLoggedInCartMagentoApiCall(initializeCartRequest: InitializeCartRequest, token: string): Promise<InitializeCartResponse> {
  const url = new URL(environment().magentoUrl + initializeCartMagento());
    
  return await getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization' : `Bearer ${token}`
      },
      body: JSON.stringify(initializeCartRequest)
    })
  );
}